module.exports = __webpack_public_path__ + "assets/img/1587370352566.ca76e05d.jpg";